( function( $ ) {
	function initBlock( section = false ) {
		const $section = section ? $( section ) : $( '.section-seo-content' );

		$section.each( function() {
			window.app.main.initFontAdjustment( this );
		} );

		/**
		 * Sets the width of the button to its largest possible state.
		 *
		 * @returns {void}
		 */
		const setWidthToButtons = () => {
			$section.find( '.js-button-set-width' ).each( ( _, button ) => {
				const $button = $( button );
				const $spans = $button.find( 'span' );

				$button.css( 'width', 'auto' );

				let maxWidth = 0;
				const buttonWidthBuffer = 10;
				const buttonPadding = parseInt( $button.css( 'padding-left' ) ) + parseInt( $button.css( 'padding-right' ) );

				// Calculate the maximum width.
				$spans.each( ( _, span ) => {
					const $span = $( span );

					$span.css( 'display', 'inline-block' );
					maxWidth = Math.max( maxWidth, $span.outerWidth() );
					$span.css( 'display', '' );
				} );

				$button.css( 'width', maxWidth + buttonPadding + buttonWidthBuffer );
			} );
		};

		/**
		 * Initialize the setting of the width of the button.
		 */
		setWidthToButtons();
		$( window ).on( 'resize', () => setTimeout( setWidthToButtons, 1000 ) );
	}

	window.app.loadBlock( initBlock, 'section-seo-content', '.section-seo-content' );
} )( jQuery );
